import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table} from "antd";
import { deleteIntroducers, getIntroducers } from "../../../apis/brokersApis";
import { useNavigate } from "react-router-dom";


const Broker = () => {
  const [brokers, setBrokers] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchBrokers();
  }, []);

  const fetchBrokers = async () => {
    try {
      const res = await getIntroducers();
      setBrokers(res.result);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Brokers:", error);
      setLoading(false);
    }
  };
  const DeleteBroker = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this Broker?"
    );
    if (isConfirmed) {
      await deleteIntroducers(id);
      setLoading(true);
      fetchBrokers();
    }
  };
  const columns = [
    {
      title: "S.No",
      dataIndex: "key",
      render: (text, record, index) => <span>{index + 1}</span>,
      width: "20%",
    },
    {
        title: "Email",
        dataIndex: "email",
        sorter: (a, b) => a.name.length - b.name.length,
        width: "30%",
    },
    {
      title: "GmId",
      dataIndex: "gmId",
      width: "30%",
    }, 
    {
        title: "CrmId",
        dataIndex: "crmId",
        width: "30%",
    },
    {
      title: "Action",
      className: "text-end",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <button
              className="dropdown-item"
              onClick={() => DeleteBroker(record.id)}
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </button>
          </div>
        </div>
        ),
      width: "30%",
    },
    ];

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <Link to="/addBrokers" className="btn btn-primary mb-3">
              Add Broker
            </Link>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <Table
                columns={columns}
                dataSource={brokers?.length > 0 ? brokers : []}
                className="table-striped"
                rowKey={(record) => record.id}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Broker;
